import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import {
    Row,
    Col,
    FormGroup,
    Input,
    Label,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardGroup,
    CardImg,
    CardTitle,
    CardSubtitle,
    CardText,
    Form,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import {
    Container,
} from "reactstrap"
import httprequester from '../../lib/httprequester'
import { Typeahead } from 'react-bootstrap-typeahead';

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Editor } from '@tinymce/tinymce-react';
import moment from "moment";

class EditArtikel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            basic: false,
            // editorState: EditorState.createEmpty(),
            // editorState: EditorState.createWithContent(
            //     ContentState.createFromBlockArray(
            //       convertFromHTML('<p>My initial content.</p>')
            //     )
            //   ),
            listCategory: [],
            listSpesialis: [],
            listMolekul: [],
            listPenyakit: [],
            listPenulis: [],
            articleJudul: '',
            articlePenulis: [],
            articlePenyakit: [],
            articleMolekul: [],
            articleSpesialis: [],
            articleKonten: '',
            articleGambar: '',
            deskripsi: null,
            deskripsiedit: null,
            chspe: false,
            chspem: false,
            chspep: false,
            chspepe: false,
            chsped: false,
            spesialisasi: '',
            molekul: '',
            penyakit: '',
            penulis: '',
            article_id: null,
            summary: '',
            prosess: false
        };
    }

    componentDidMount() {
        this.getCategory();
        this.getLOV();
        // this.getArtikel();
        this.getDetailArtikel();
    }

    static propTypes = {
        history: PropTypes.object.isRequired
    }

    getArtikel = () => {
        let router = window.location.href
        let routerSplitter = router.split("/");
        console.log('hasil', routerSplitter)

        let body = {
            "category": "",
            "search": "",
            "value": "",
            "status": routerSplitter[6],
            "page": 2,
            "limit": 10,
            "urutan": "article_title ASC"
        }

        // console.log("body =>", body)
        httprequester.postnobody('user/get_article', body, {
            success: async function (response) {
                let data = []
                // let cek = response.data.result.data
                // console.log("res => ", cek)
                if (response.data.message == "success") {
                    console.log("res2 => ", response.data.result.data.dataRows)

                    // if(response.data.result.data.length)
                    response.data.result.data.dataRows.forEach(async (v, key) => {
                        await data.push({
                            article_category: v[0],
                            article_content: v[1],
                            article_penulis: v[2],
                            created_at: v[3],
                            article_slug: v[4],
                            created_by: v[5],
                            article_molekul: v[6],
                            article_id: v[7],
                            article_spesialis: v[8],
                            article_title: v[9],
                            article_status: v[10],
                            article_penyakit: v[11],
                            article_tags: v[13],
                            article_summary: v[12],
                            article_thumbnail: v[14]
                        })
                    })
                    // console.log("data => ",data);
                    // console.log("ID 1 => ",routerSplitter[5]);
                    // console.log("ID 2 => ",data);
                    let edit = data.find(o => o.article_id == routerSplitter[5])
                    // console.log('edit',edit)

                    this.setState({
                        article_id: routerSplitter[5],
                        articleJudul: edit.article_title,
                        articleGambar: edit.article_thumbnail,
                        deskripsiedit: edit.article_content,
                        spesialisasi: edit.article_spesialis,
                        molekul: edit.article_molekul,
                        penyakit: edit.article_penyakit,
                        penulis: edit.article_penulis,
                        summary: edit.article_summary
                    })
                }
                // console.log("artikel => ", this.state.listArtikel)
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    getDetailArtikel = () => {
        let router = window.location.href
        let routerSplitter = router.split("/");
        console.log('hasil', routerSplitter[5])

        let body = {
            "article_id": routerSplitter[5]
        }

        httprequester.postnobody('artikel/detail', body, {
            success: async function (response) {
                let data = []
                // let cek = response.data.result
                // console.log("res => ", response)
                if (response.data.message == "success") {

                    response.data.settings.datarows.forEach(async (v, key) => {
                        await data.push({
                            article_category: v[0],
                            article_content: v[1],
                            article_penulis: v[2],
                            created_at: v[3],
                            article_slug: v[4],
                            created_by: v[5],
                            article_molekul: v[6],
                            article_id: v[7],
                            article_spesialis: v[8],
                            article_title: v[9],
                            article_status: v[10],
                            article_penyakit: v[11],
                            article_tags: v[13],
                            article_summary: v[12],
                            article_thumbnail: v[14]
                        })
                    })

                    let edit = data.find(o => o.article_id == routerSplitter[5])

                    this.setState({
                        article_id: routerSplitter[5],
                        articleJudul: edit.article_title,
                        articleGambar: edit.article_thumbnail,
                        deskripsiedit: edit.article_content,
                        spesialisasi: edit.article_spesialis,
                        molekul: edit.article_molekul,
                        penyakit: edit.article_penyakit,
                        penulis: edit.article_penulis,
                        summary: edit.article_summary
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    back = () => {
        this.props.history.push(`/artikel`)
    }

    handleEditorChange = (e) => {
        // console.log('as', e.target.getContent())
        this.setState({
            deskripsi: e.target.getContent()
        })
    }

    clearKonten = () => {
        this.setState({
            basic: false,
            // editorState: EditorState.createEmpty(),
            articleJudul: '',
            articlePenulis: [],
            articleKonten: '',
            articleGambar: '',
            articleSpesialis: [],
            articleMolekul: [],
            articlePenyakit: []
        });
    }

    getCategory = () => {
        httprequester.get('category/getall', {
            success: async function (response) {

                // console.log("resCat => ", response)
                if (response.data.message == "success") {
                    this.setState({
                        listCategory: response.data.detailMessage
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    getLOV = () => {
        httprequester.get('artikel/lov', {
            success: async function (response) {

                // console.log("resLOV => ", response)
                if (response.data.message == "success") {
                    let datapenyakit = []
                    response.data.detailPenyakit.forEach((v, key) => {
                        // console.log('v',v);
                        datapenyakit.push({
                            penyakit_id: v.penyakit_id,
                            penyakit_name: v.penyakit_name == null ? '-' : v.penyakit_name
                        })
                    })

                    this.setState({
                        listSpesialis: response.data.detailSpecialist,
                        listMolekul: response.data.detailMolekul,
                        listPenyakit: datapenyakit,
                        listPenulis: response.data.detailPenulis
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    saveArticle = () => {
        let slugLower = this.state.articleJudul.toLowerCase();
        // /\s/g
        let slugRep = slugLower.replace(/\s/g, '-');

        const { admin_name } = JSON.parse(localStorage.getItem('user'))

        let body = {
            "article_id": this.state.article_id,
            "article_title": this.state.articleJudul,
            // "article_slug": slugRep,
            "article_thumbnail": this.state.articleGambar,
            "article_penulis": this.state.articlePenulis.toString() ? this.state.articlePenulis.toString() : this.state.penulis,
            "article_penyakit": this.state.articlePenyakit.toString() ? this.state.articlePenyakit.toString() : this.state.penyakit,
            "article_molekul": this.state.articleMolekul.toString() ? this.state.articleMolekul.toString() : this.state.molekul,
            "article_spesialis": this.state.articleSpesialis.toString() ? this.state.articleSpesialis.toString() : this.state.spesialisasi,
            "article_status": "Unpublished",
            "article_content": this.state.deskripsi ? this.state.deskripsi : this.state.deskripsiedit,
            "article_summary": this.state.summary
        }
        console.log("body =>", body)
        this.setState({
            prosess: true
        })

        let dx = {
            content_id: this.state.article_id,
            content_penulis: this.state.penulis,
            content_title: this.state.articleJudul,
            content_penyakit: this.state.penyakit,
            content_molekul: this.state.molekul,
            content_spesialis: this.state.spesialisasi,
            hp_type: 'article'
        }
        httprequester.postarticle('artikel/update', body, {
            success: async function (response) {
                console.log("res => ", response)
                if (response.data.message == "success") {
                    httprequester.postarticle('homepage/lov_destruct', dx, {
                        success: async function (responses) {
                            console.log(responses)
                        }.bind(this),
                        error: function (err) {
                            console.log("error", err)
                        }.bind(this)
                    })
                    this.setState({
                        basic: true,
                        prosess: false
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    handleChangePenulis(e) {
        this.setState({
            // articlePenulis: e
            articlePenulis: e
        })
        // console.log("INIT N", this.state.articlePenulis);
        // console.log("INIT N1", e[0].penulis_name);
    }

    handleChangeSpesialis(e) {

        // if(e[0].hasOwnProperty('specialist_name')){
        //     console.log("A")
        // }else if(e[0].hasOwnProperty('customOption')) {
        //     console.log("B")
        // }else{
        //     console.log("C")
        // }

        this.setState({
            // articleSpesialis: e
            articleSpesialis: e
        })
        console.log("INIT S", e);
        // console.log("INIT S1", e[0].specialist_name);
    }

    handleChangeMolekul(e) {
        this.setState({
            // articleMolekul: e
            articleMolekul: e
        })
        console.log("INIT M", e);
        // console.log("INIT M1", e[0].molekul_name);
    }

    handleChangePenyakit(e) {
        this.setState({
            // articlePenyakit: e
            articlePenyakit: e
        })
        console.log("INIT P", e);
        // console.log("INIT P1", e[0].penyakit_name);
    }

    render() {
        // console.log("hacep => ", this.state.articleKonten)
        const option = this.state.listSpesialis.map(o => o.specialist_name)
        const optionMolekul = this.state.listMolekul.map(o => o.molekul_name)
        const optionPenyakit = this.state.listPenyakit.map(o => o.penyakit_name)
        const optionPenulis = this.state.listPenulis.map(o => o.penulis_name)
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Edit Artikel</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Artikel" breadcrumbItem="Edit Artikel" />

                        {this.state.basic ? (
                            <SweetAlert
                                success
                                title="Artikel berhasil di simpan"
                                onConfirm={() => this.back()}
                            ></SweetAlert>
                        ) : null}

                        {this.state.prosess ? (
                            <SweetAlert title="proses simpan ..." showConfirm={false} >
                            </SweetAlert>
                        ) : null}

                        <AvForm >
                            <Row>
                                <Col lg={12}>
                                    <Card>
                                        <CardBody>
                                            {/* <CardTitle className="mb-4">Form Grid layout</CardTitle> */}

                                            <Form>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-firstname-Input">Judul Artikel</Label>
                                                    <Input
                                                        id="artikelJudul"
                                                        type="input"
                                                        placeholder="Input Judul Artikel"
                                                        onChange={(e) => this.setState({ articleJudul: e.target.value })}
                                                        value={this.state.articleJudul}
                                                    />
                                                </div>

                                                {/* <div className={this.state.col}>
                                                <div className="form-group">
                                                    <label>Spesialis</label>
                                                    <Typeahead
                                                        labelKey={option => `${option.category_name}`}
                                                        options={[...this.state.listCategory]}
                                                        onChange={(e) => this.handleChangeSpesialis(e)}
                                                    />
                                                </div>
                                            </div> */}

                                                {/* <Row>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-firstname-Input">Kategori</Label>
                                                        <Input
                                                            type="select"
                                                            name="select"
                                                            id="select"
                                                            onChange={(e) => this.setState({ articleCategory: e.target.value })}
                                                            value={this.state.articleCategory}
                                                        >
                                                            <option value="">Pilih Kategori</option>
                                                            {this.state.listCategory ? this.state.listCategory.map((cat) => (
                                                                <option key={cat.category_id} value={cat.category_name}>{cat.category_name}</option>
                                                            )) : null}
                                                        </Input>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-email-Input">Tags</Label>
                                                        <Input
                                                            type="email"
                                                            className="form-control"
                                                            id="horizontal-email-Input"
                                                            placeholder="Input Tags"
                                                            disabled
                                                        />
                                                    </div>
                                                </Col>
                                            </Row> */}

                                                <Row>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <Label for="exampleSpesialisasi">
                                                                    Penulis
                                                                </Label>
                                                                <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspepe: !this.state.chspepe })} >ubah</a>
                                                            </div>
                                                            {/* <Label htmlFor="formrow-firstname-Input">Penulis</Label> */}
                                                            {(!this.state.chspepe) ?
                                                                <AvField
                                                                    name="judul"
                                                                    disabled
                                                                    type="text"
                                                                    value={this.state.penulis} required />
                                                                : <Typeahead
                                                                    // allowNew
                                                                    id="basic-typeahead-multiple"
                                                                    multiple
                                                                    placeholder="Pilih Penulis"
                                                                    labelKey="name"
                                                                    options={optionPenulis}
                                                                    onChange={(e) => this.handleChangePenulis(e)}
                                                                    selected={this.state.articlePenulis}
                                                                />
                                                            }

                                                            {/* <Input
                                                            type="input"
                                                            placeholder="Input Nama Penulis"
                                                            onChange={(e) => this.setState({ articlePenulis: e.target.value })}
                                                            value={this.state.articlePenulis}
                                                        /> */}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="formrow-email-Input">URL Gambar Thumbnail</Label>
                                                            <Input
                                                                id="artikelThumbnail"
                                                                type="input"
                                                                placeholder="Input Link Thumbnail"
                                                                onChange={(e) => this.setState({ articleGambar: e.target.value })}
                                                                value={this.state.articleGambar}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col lg={4}>
                                                        <div className="mb-3">
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <Label for="exampleSpesialisasi">
                                                                    Spesialisasi
                                                                </Label>
                                                                <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspe: !this.state.chspe })} >ubah</a>
                                                            </div>
                                                            {/* <Label htmlFor="formrow-InputCity">Spesialis</Label> */}
                                                            {(!this.state.chspe) ?
                                                                <AvField
                                                                    name="judul"
                                                                    disabled
                                                                    type="text"
                                                                    value={this.state.spesialisasi} required />
                                                                : <Typeahead
                                                                    id="basic-typeahead-multiple"
                                                                    multiple
                                                                    placeholder="Pilih Spesialis"
                                                                    labelKey="name"
                                                                    options={option}
                                                                    onChange={(e) => this.handleChangeSpesialis(e)}
                                                                    selected={this.state.articleSpesialis}
                                                                />
                                                            }
                                                        </div>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <div className="mb-3">
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <Label for="exampleSpesialisasi">
                                                                    Molekul
                                                                </Label>
                                                                <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspem: !this.state.chspem })} >ubah</a>
                                                            </div>
                                                            {/* <Label htmlFor="formrow-InputState">Molekul</Label> */}
                                                            {(!this.state.chspem) ?
                                                                <AvField
                                                                    name="judul"
                                                                    disabled
                                                                    type="text"
                                                                    value={this.state.molekul} required />
                                                                : <Typeahead
                                                                    id="basic-typeahead-multiple"
                                                                    multiple
                                                                    placeholder="Pilih Molekul"
                                                                    labelKey="name"
                                                                    options={optionMolekul}
                                                                    onChange={(e) => this.handleChangeMolekul(e)}
                                                                    selected={this.state.articleMolekul}
                                                                />
                                                            }
                                                        </div>
                                                    </Col>

                                                    <Col lg={4}>
                                                        <div className="mb-3">
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <Label for="exampleSpesialisasi">
                                                                    Penyakit
                                                                </Label>
                                                                <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspep: !this.state.chspep })} >ubah</a>
                                                            </div>
                                                            {/* <Label htmlFor="formrow-InputZip">Penyakit</Label> */}
                                                            {(!this.state.chspep) ?
                                                                <AvField
                                                                    name="judul"
                                                                    disabled
                                                                    type="text"
                                                                    value={this.state.penyakit} required />
                                                                : <Typeahead
                                                                    id="basic-typeahead-multiple"
                                                                    multiple
                                                                    placeholder="Pilih Penyakit"
                                                                    labelKey="name"
                                                                    options={optionPenyakit}
                                                                    onChange={(e) => this.handleChangePenyakit(e)}
                                                                    selected={this.state.articlePenyakit}
                                                                />
                                                            }

                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg={12}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="formrow-InputCity">Summary</Label>
                                                            <Input type="textarea" onChange={(e) => this.setState({ summary: e.target.value })} value={this.state.summary} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </AvForm>

                        <AvForm>
                            <Row style={{ paddingTop: 10 }}>
                                <Col xs="12" md="12">
                                    <Card>
                                        <CardBody>
                                            <Form method="post">
                                                <Editor
                                                    apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                                                    initialValue={this.state.deskripsiedit}
                                                    content={this.state.deskripsi}
                                                    init={{
                                                        height: 500,
                                                        menubar: false,
                                                        plugins: [
                                                            'advlist autolink lists link image charmap print preview anchor',
                                                            'searchreplace visualblocks code fullscreen',
                                                            'insertdatetime media table paste code help wordcount'
                                                        ],
                                                        toolbar: 'undo redo | formatselect | ' +
                                                            'bold italic forecolor backcolor | alignleft aligncenter ' +
                                                            'alignright alignjustify | bullist numlist outdent indent lineheight | ' +
                                                            'removeformat link',
                                                        content_style: 'body { font-family:Poppins,Arial,sans-serif; }',
                                                        line_height_formats: '0.2 0.4 0.6 0.8 1 1.2 1.4 1.6 2',
                                                    }}
                                                    onChange={this.handleEditorChange}
                                                />
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </AvForm>
                        <Row style={{ paddingTop: 10 }}>
                            <Col xs="12" md="12">
                                <Card>
                                    <Button type="submit" className="btn btn-primary w-md" onClick={() => this.saveArticle()}>
                                        Submit Artikel
                                    </Button>
                                </Card>
                            </Col>
                        </Row>
                        {/* <Row md="10" style={{ paddingTop: 8, justifyContent: "end", alignItems: "end" }}>
                            <Button color="danger" onClick={() => this.saveArticle()}>
                                Submit Artikel
                            </Button>
                        </Row> */}
                    </Container>
                </div>
            </React.Fragment >
        )
    }
}

export default EditArtikel;
